<script setup lang="ts">
import {Dialog, DialogPanel} from '@headlessui/vue';
import CustomButton from '@/components/common/input/CustomButton.vue';

const emits = defineEmits(['close']);
defineProps({
    isOpen: {type: Boolean, required: true},
    title: {type: String, default: ''},
    message: {type: String, default: ''},
    confirmText: {type: String, default: '확인'},
});
</script>

<template>
    <Dialog @close="emits('close')" :open="isOpen">
        <div class="base-alert-backdrop">
            <DialogPanel class="base-alert-content">
                <div
                    v-if="title"
                    class="base-alert__title"
                    v-html="title"
                ></div>

                <div
                    class="base-alert__description"
                    v-if="message"
                    v-html="message"
                ></div>
                <div class="base-alert__description" v-else>
                    <slot></slot>
                </div>
                <div class="base-alert__btn-wrap">
                    <CustomButton
                        type="button"
                        @click="emits('close')"
                        class="base-alert-btn base-alert-btn__close"
                    >
                        {{ confirmText }}</CustomButton
                    >
                </div>
            </DialogPanel>
        </div>
    </Dialog>
</template>

<style lang="scss" scoped>
.base-alert-backdrop {
    position: fixed;
    top: 0;
    height: 0;
    width: 100vw;
    height: 100vh;
    z-index: $modal-z-index;
    background: rgba(0, 0, 0, 0.25);
}
.base-alert-content {
    padding: 16px 20px 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 335px;
    max-height: calc(100vh - 120px);
    background: $white;
    border-radius: 12px;
    color: $NDS20;
    word-break: break-all;
    font-size: 16px;
    line-height: 24px;
    overflow-y: auto;
    z-index: $modal-z-index;

    @media (max-width: 500px) {
        width: 80%;
    }

    .base-alert__title {
        color: $NDS20;
        font-size: 18px;
        padding: 13px 0 8px;
        font-weight: 700;
        line-height: 22px;
    }

    .base-alert__description {
        margin-top: 8px;
        line-height: 24px;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
    }

    .base-alert__btn-wrap {
        display: flex;
        justify-content: flex-end;
        padding: 20px 0;
    }

    .base-alert-btn {
        padding: 0;
        width: 100%;
        height: 48px;
        background: $btn-primary;
        color: $white;
        border: 0;
        border-radius: 10px;
        outline: 0;
        cursor: pointer;
        transition: 0.3s ease;
        font-weight: 600;

        &:hover {
            background: $btn-primary-hover;
            opacity: 1;
        }

        &__close {
            &:hover {
                background-color: $btn-primary-hover;
                opacity: 1;
            }
        }
    }
}

.v-enter-active,
.v-leave-active {
    transition: all 2s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
